import { percent } from "csx";
import { Vertical } from "gls";
import { SidebarLabel } from "./SidebarLabel";

interface SidebarItemGroupProps {
  label: string;
  isCollapsed?: boolean;
}

export const SidebarItemGroup: FCWithChildren<SidebarItemGroupProps> = ({
  label,
  isCollapsed,
  children,
}) => {
  return (
    <Vertical spacing={0} width={percent(100)}>
      <SidebarLabel label={label} isCollapsed={isCollapsed} />
      <Vertical spacing={isCollapsed ? 0 : 10}>{children}</Vertical>
    </Vertical>
  );
};
